module.exports = __webpack_public_path__ + "img/tic-tac-3.8c6ecf63.png";